import React, { useEffect, useState } from "react";
import HyvorTalk from "hyvor-talk-react";
function Comments(props) {
  const [hyvor, setState] = useState([]);

  useEffect(() => {
    setState({
      href: props.href,
    });
  }, []);

  return <HyvorTalk.Embed websiteId={713} id={hyvor.href} loadMode="scroll" />;
}

export default Comments;
